/**
 * 订单管理 挂号统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>挂号统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <!-- <el-input size="small" v-model="formInline.department_name" placeholder="输入科室名称"></el-input> -->
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.department_id" placeholder="请选择科室">
          <el-option v-for="(item,index) in department" :label="item.key" :value="item.value" :key="index"></el-option>

        </el-select>
      </el-form-item>

      <el-form-item>
          <el-date-picker
            v-model="formInline.date"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            >
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>

    </el-form>
    <!--列表  :summary-method="getSummaries"-->

    <el-table size="small" :data="ghs" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"  style="width: 50%;">


      <el-table-column prop="gh_count" align="center"  label="挂号数" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="yy_count" align="center" label="预约挂号数" width="250" show-overflow-tooltip>
      </el-table-column>

      <!-- <el-table-column prop="today_count_money" align="center" label="当日挂号金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="yy_count_money" label="预约挂号金额" width="140" show-overflow-tooltip>
      </el-table-column> -->

    </el-table>


 <!-- <div class="echart" id="mychart" :style="myChartStyle"></div> -->
<!-- <div id="myChart3" :style="{width: '100%', height: '300px'}"></div> -->

  </div>
</template>

<script>
import { OrderList, orderToHis,wxRefund,OrderListall} from '../../api/payMG'
import { ghjl,ghjlall,getdepartment} from '../../api/baseset'
import Pagination from '../../components/Pagination'


export default {
  data() {
    return {
      loading: false,
      refundVisible: false,

      formInline: {
        page: 1,
        limit: 10,
        department_name:'',
        date:'',
        department_id:''
      },
      listData: [], //订单数据
      department_name:'',
      today_data:'',
      yy_data:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       myChart: {},
       pieData: [],
      pieName: [],
       myChartStyle: { float: "left", width: "100%", height: "400px" }, //图表样式
      ghs:[],
      department:[]

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getdata(this.formInline)
    this.dept();
  },
  mounted() {

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

     getSummaries(param) {

          },
      dept(){

        getdepartment().then(res => {

          if(res.code == 0){
            this.department = res.data
          }else{
           // this.$message.error(res.msg)
          }
        })

      },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
        ghjlall(parameter)
         .then(res => {
          // console.log(res)
           this.loading = false
            this.ghs = res.data;
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },

    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 50
      }
    },
    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      // this.getdata(this.formInline)
    },
    detail(row){
        //console.log(id)
         this.$router.push('/charts/ghtjdetail/'+row.tj_date);
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 50
      if(this.formInline.date ==''){

        this.$message.error('请选择时间段')
        return ;
      }
      //console.log(this.formInline)
      this.getdata(this.formInline)
    },

        drawLine(){
              // 基于准备好的dom，初始化echarts实例
              let myChart3 = this.$echarts.init(document.getElementById('myChart3'))
              // 绘制图表
              console.log()
             let department_name = this.department_name
             console.log(department_name,"---------")
              myChart3.setOption({
                title: { text: '报表统计' },  //图表标题

                tooltip: {},
                xAxis: {
                  name: '科室名称',     //x轴标题
                  data: this.department_name
                },
                yAxis: {

                },
                series: [
                      {
                        type: 'bar',
                        data: this.today_data,

                       itemStyle: {
                          color: '#FC5531',
                          shadowColor: '#FC5531',
                          borderType: 'dashed',
                          opacity: 0.5
                          }
                      },

                      {
                        type: 'bar',
                        data: this.yy_data,
                        itemStyle: {
                        color: '#409EFF',
                        shadowColor: '#409EFF',
                        borderType: 'dashed',
                        opacity: 0.5
                         }
                      }
              ]
              });

            }



  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.tubiao{
  width: 35%;
  height: 300px;
  border: solid 1px red;
  float: left;
}
#myChart3{
  background-color: white !important;
  margin-top:30px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/ghtjall.vue